// Vendors
import Vue from 'vue';
import Slick from 'vue-slick';

// Global components
import ProductItem from './components/product-item.js';
import MaCode from './components/ma-code.vue';
import AnnouncementBar from './components/announcement-bar'

// Template specific components
import Collection from './components/collection.js';
import Product from './components/product.js';
import ProductRelated from './components/product-related.js';
import CustomerAddresses from './components/customer-addresses.js';
import CustomerLogin from './components/customer-login.js';
import Cart from './components/cart.js';
import ExclusiveProducts from './components/exclusive-products.js';
import Register from './components/register.js';

import MenuAndImageSlider from './components/menu-and-image-slider.vue';
import KeenSlider from './components/keen-slider.vue';

function initVueInstance(element) {
    new Vue({
        el: element,

        delimiters: ['${', '}'],

        components: {
            Slick,
            ProductItem,
            MaCode,
            AnnouncementBar,

            Collection,
            Product,
            ProductRelated,
            CustomerAddresses,
            CustomerLogin,
            Cart,
            
            KeenSlider,
            MenuAndImageSlider,
            ExclusiveProducts,
            Register
        }
    });
}

const initVue = () => document.querySelectorAll('[vue-init]').forEach(element => {
    initVueInstance(element);
});

initVue();

// Fix for theme editor preview
document.addEventListener('shopify:section:load', (event) => {
    // Vue HTML tags disappear so it can't reinitialise, causing the header to break
    if (event.target.id.includes('megamenu')) return
    initVue();
})